import { object, string, array } from "yup"

const forwardingGroupSchema = object().shape({
  name: string().required(),
  emails: array().of(string().email().required("Required")).min(1).required(),
  classifications: array().of(string()).required(),
})

export default array().of(forwardingGroupSchema)
